export default __webpack_public_path__ + "static/media/405fe6bae001314fd01d525a4c4d2d7e.svg";